import { string, struct } from 'io-ts/Decoder';

import { Id } from './Id';

export const RefItem = struct({
	id: Id,
	name: string,
});
